module.exports = __webpack_public_path__ + "static/media/cloud.dd013f4b.svg";